// GENX theme — vanilla JS, no dependencies
(() => {
  'use strict';

  const moneyFormat = (cents) => {
    const dollars = (cents / 100);
    return '$' + dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  // ---------- product gallery (main + thumbnails) ----------
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const src = btn.getAttribute('data-src');
        const isVideo = btn.getAttribute('data-type') === 'video';
        if (isVideo) {
          main.innerHTML = `<video autoplay muted loop playsinline src="${src}"></video>`;
        } else {
          main.innerHTML = `<img src="${src}" alt="">`;
        }
        thumbs.forEach((b) => b.classList.toggle('is-active', b === btn));
      });
    });
  }

  // ---------- quantity steppers ----------
  const bindQty = (wrap) => {
    const input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
      input.value = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    wrap.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };
  document.querySelectorAll('[data-qty]').forEach(bindQty);

  // ============================================================
  // CART DRAWER
  // ============================================================
  const drawer = document.querySelector('[data-cart-drawer]');

  const openDrawer = () => {
    drawer?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  };
  const closeDrawer = () => {
    drawer?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  document.querySelectorAll('[data-cart-open]').forEach((b) =>
    b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); })
  );
  document.querySelectorAll('[data-cart-close]').forEach((b) =>
    b.addEventListener('click', (e) => { e.preventDefault(); closeDrawer(); })
  );
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Render cart in drawer
  const refreshCart = async () => {
    if (!drawer) return;
    const items = drawer.querySelector('[data-cart-items]');
    const empty = drawer.querySelector('[data-cart-empty]');
    const footer = drawer.querySelector('[data-cart-footer]');
    const subtotal = drawer.querySelector('[data-cart-subtotal]');
    const tpl = drawer.querySelector('[data-cart-line-template]');

    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();

      // update header counters everywhere
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });

      // clear previously-rendered lines
      items.querySelectorAll('.cart-line').forEach((n) => n.remove());

      const promoWrap = drawer.querySelector('[data-cart-promo-wrap]');

      if (cart.item_count === 0) {
        if (empty) empty.hidden = false;
        if (footer) footer.hidden = true;
        if (promoWrap) promoWrap.hidden = true;
      } else {
        if (empty)  empty.hidden = true;
        if (footer) footer.hidden = false;
        if (promoWrap) promoWrap.hidden = false;

        if (!tpl) {
          console.error('cart drawer: line item template not found');
        } else {
          cart.items.forEach((item) => {
            const node = tpl.content.firstElementChild.cloneNode(true);
            node.dataset.lineKey = item.key;
            const linkA = node.querySelector('.cart-line__img');
            const img = node.querySelector('.cart-line__img img');
            const titleA = node.querySelector('.cart-line__title');
            const variantEl = node.querySelector('.cart-line__variant');
            const priceEl = node.querySelector('.cart-line__price');
            const totalEl = node.querySelector('.cart-line__total');
            const qtyInput = node.querySelector('[data-line-qty]');
            const removeBtn = node.querySelector('[data-line-remove]');

            if (linkA) linkA.href = item.url;
            if (img && item.image) img.src = item.image.replace(/_(small|medium|large|grande)/, '_200x');
            if (img && item.product_title) img.alt = item.product_title;
            if (titleA) { titleA.textContent = item.product_title; titleA.href = item.url; }
            if (variantEl && item.variant_title && item.variant_title !== 'Default Title') {
              variantEl.hidden = false;
              variantEl.textContent = item.variant_title;
            }
            if (priceEl) priceEl.textContent = moneyFormat(item.price);
            if (totalEl) totalEl.textContent = moneyFormat(item.line_price);
            if (qtyInput) qtyInput.value = item.quantity;
            bindQty(node.querySelector('[data-qty]'));
            qtyInput?.addEventListener('change', () => updateLine(item.key, parseInt(qtyInput.value, 10) || 0));
            removeBtn?.addEventListener('click', () => updateLine(item.key, 0));
            items.appendChild(node);
          });
        }
        if (subtotal) subtotal.textContent = moneyFormat(cart.total_price);
      }

      updateProgress(cart.total_price);
    } catch (err) {
      console.error('refreshCart failed', err);
    }
  };

  // ---------- promo / discount code ----------
  const promoApplyButtons = document.querySelectorAll('[data-cart-promo-apply]');
  promoApplyButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = drawer?.querySelector('[data-cart-promo]');
      const code = (input?.value || '').trim().toUpperCase();
      if (!code) {
        input?.focus();
        return;
      }
      btn.textContent = 'Applying…';
      btn.disabled = true;
      // Shopify's discount URL applies the code to the customer session
      // and follows the ?redirect URL. We bounce back to /cart so the
      // updated totals show; we reopen the drawer via a query flag.
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=/cart%3Fcart_drawer%3Dopen%26code%3D${encodeURIComponent(code)}`;
    });
  });

  // Auto-open drawer if URL has ?cart_drawer=open (after a /discount/ redirect)
  if (location.search.includes('cart_drawer=open')) {
    setTimeout(() => {
      openDrawer();
      const params = new URLSearchParams(location.search);
      const code = params.get('code');
      const msg = drawer?.querySelector('[data-cart-promo-msg]');
      if (msg && code) {
        msg.hidden = false;
        msg.textContent = `Code ${code} applied — discount shows at checkout.`;
      }
    }, 80);
  }

  const updateLine = async (key, quantity) => {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      await refreshCart();
    } catch (err) {
      console.error('updateLine failed', err);
    }
  };

  // Free shipping progress bar
  const updateProgress = (totalCents) => {
    if (!drawer) return;
    const wrap = drawer.querySelector('[data-cart-progress]');
    if (!wrap) return;
    const threshold = parseInt(wrap.dataset.threshold || '9900', 10);
    const fill = wrap.querySelector('[data-cart-progress-fill]');
    const text = wrap.querySelector('[data-cart-progress-text]');
    if (threshold <= 0) { wrap.style.display = 'none'; return; }
    const pct = Math.min(100, Math.round((totalCents / threshold) * 100));
    if (fill) fill.style.width = pct + '%';
    if (totalCents >= threshold) {
      wrap.classList.add('is-met');
      if (text) text.innerHTML = `<strong>You unlocked free US shipping. ✓</strong>`;
    } else {
      wrap.classList.remove('is-met');
      const remaining = threshold - totalCents;
      if (text) text.innerHTML = `Add <strong>${moneyFormat(remaining)}</strong> for free US shipping.`;
    }
  };

  // ============================================================
  // PRODUCT FORM (ajax add-to-cart) -> opens drawer
  // ============================================================
  const productForm = document.querySelector('form[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = productForm.querySelector('[data-add-to-cart]');
      const original = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      try {
        const fd = new FormData(productForm);
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        });
        if (!r.ok) throw new Error(await r.text());
        btn.textContent = 'Added ✓';
        if (drawer) {
          openDrawer();
        } else {
          window.location.href = '/cart';
        }
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 800);
      } catch (err) {
        btn.textContent = 'Error — try again';
        btn.disabled = false;
        console.error(err);
      }
    });
  }

  // Sticky CTA "Add to cart" button just submits the main product form
  document.querySelectorAll('[data-sticky-add]').forEach((btn) => {
    btn.addEventListener('click', () => {
      productForm?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  });

  // ============================================================
  // STICKY CTA — show/hide based on scroll past main buy box
  // ============================================================
  const stickyCTA = document.querySelector('[data-sticky-cta]');
  if (stickyCTA) {
    const trigger = document.querySelector('[data-sticky-trigger]');
    if (trigger) {
      const obs = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          stickyCTA.classList.toggle('is-visible', !e.isIntersecting);
          stickyCTA.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
        });
      }, { threshold: 0, rootMargin: '-200px 0px 0px 0px' });
      obs.observe(trigger);
    }
  }

  // ============================================================
  // MOBILE NAV DRAWER
  // ============================================================
  const mobileNav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-mobile-nav-open]').forEach((b) =>
    b.addEventListener('click', (e) => {
      e.preventDefault();
      mobileNav?.classList.add('is-open');
      mobileNav?.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    })
  );
  document.querySelectorAll('[data-mobile-nav-close]').forEach((b) =>
    b.addEventListener('click', (e) => {
      e.preventDefault();
      mobileNav?.classList.remove('is-open');
      mobileNav?.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    })
  );

  // ============================================================
  // VIDEO DEMO click-to-play
  // ============================================================
  document.querySelectorAll('[data-video-demo]').forEach((wrap) => {
    const player = wrap.querySelector('[data-video-player]');
    const playBtn = wrap.querySelector('[data-video-play]');
    if (!player || !playBtn) return;
    playBtn.addEventListener('click', () => {
      wrap.classList.add('is-playing');
      player.controls = true;
      player.play().catch(() => { /* autoplay denied */ });
    });
  });

  // initial cart count load (refresh on page entry to keep header in sync)
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then((r) => r.json())
    .then((cart) => {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });
    })
    .catch(() => {});
})();
